// extracted by mini-css-extract-plugin
export default {"description":"Description_description__E2v7o","description__title":"Description_description__title__K0dQk","description__text":"Description_description__text__WIRuD"};